import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MailOpenFile = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 12 12" {...props}>
    <path
      d="M10.3309 4.53321L6.11394 0.316283C5.95538 0.157716 5.74444 0.0700684 5.52005 0.0700684C5.29565 0.0700684 5.08471 0.157353 4.92615 0.316283L4.00675 1.23568H2.61202V2.63005L0.672852 4.56885V10.9301H10.3672V4.56958L10.3312 4.53358L10.3309 4.53321ZM9.92936 4.6805L8.42771 6.18216V3.17921L9.92936 4.68087V4.6805ZM5.2 0.590138C5.37093 0.419206 5.66879 0.419206 5.83972 0.590138L6.4849 1.23532H4.55483L5.2 0.590138ZM6.87223 1.623L8.04002 2.79116V6.56985L7.14208 7.46779L6.11322 6.43892C5.95465 6.28035 5.74371 6.19271 5.51932 6.19271C5.29492 6.19271 5.08399 6.28035 4.92542 6.43892L3.88128 7.4827L2.99898 6.6004V1.62337H6.87186L6.87223 1.623ZM1.29366 4.49612L2.61166 3.17812V6.21235L1.09436 4.69505L1.29366 4.49575V4.49612ZM1.06018 5.52098V5.20967L3.60706 7.75655L3.57833 7.78565L3.57797 7.78528L1.06018 10.3031V5.52098ZM1.36967 10.542L1.57806 10.3336H1.57879L5.2 6.71278C5.37093 6.54184 5.66879 6.54184 5.83972 6.71278L9.66969 10.542H1.36967ZM9.97919 5.26713V10.3034L7.41666 7.74201L9.97919 5.17948V5.26749V5.26713Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M4.1626 2.78644H6.87714V3.17413H4.1626V2.78644Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M4.1626 5.11328H6.87714V5.50097H4.1626V5.11328Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M4.1626 3.94989H6.1014V4.33758H4.1626V3.94989Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
